import { getStorage, ref, updateMetadata, uploadBytesResumable } from "firebase/storage";

import { PHOTO_COLLECTIONS_FOLDER, SLASH, STATE_CHANGED } from "../constants";

const getFileNameAndExtension = (index: number, file: File): string => {
  return index + '.' + file.name.split('.').pop();
}

const uploadImagesInBulk = async (files: File[], collectionId: string, batchSize: number, onProgress?: (completed: number, total: number) => void): Promise<void> => {
  const folderPath = PHOTO_COLLECTIONS_FOLDER + SLASH + collectionId;
  try {
    const total = files.length;
    let completed = 0;
    for (let i = 0; i < files.length; i += batchSize) {
      const batch = files.slice(i, i + batchSize);
      const uploadPromises = batch.map((file, batchIndex) => {
        const actualIndex = i + batchIndex;
        const imageRef = ref(getStorage(), folderPath + SLASH + getFileNameAndExtension(actualIndex, file));
        return new Promise((resolve, reject) => {
          const uploadTask = uploadBytesResumable(imageRef, file);
          uploadTask.on(
            STATE_CHANGED,
            (snapshot) => {
              // Track progress of one file if uploading zip
              // const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            },
            (error) => {
              console.error(`Error uploading file ${actualIndex}: ${error}`);
              reject(error);
            },
            async () => {
              try {
                await updateMetadata(imageRef, {
                  customMetadata: {
                    originalPhotoName: file.name
                  }
                });
                completed++;
                onProgress?.(completed, total);
                resolve(true);
              } catch (error) {
                console.error(`Error updating metadata for file ${actualIndex}: ${error}`);
              }
            }
          );
        });
      });
      await Promise.all(uploadPromises);
    }
  } catch (e) {
    console.error("Error uploading images in bulk: ", e);
  }
}

const StorageService = {
  uploadImagesInBulk
}

export default StorageService;
